import React from 'react';
import KickImage from 'Reuseables/KickImage';
import classNames from 'classnames';
import propTypes from 'prop-types';

import Thumbnail from './Thumbnail';
import NoThumbnail from './NoThumbnail';
import emptySneakerImg from '../../../../images/emptysneakers2.png';
import { getCacheImage } from '../../../../config'

const SingleThumbnail = ({src, alt, noImage, className, ...props}) => {
  return (
    <div className={classNames("single-thumbnail-container", className)} {...props}>
      {
        noImage?
        <NoThumbnail src={emptySneakerImg} alt="No Image..."/>
        :
        <Thumbnail src={getCacheImage(src)} alt={alt}/>
      }
    </div>
  )
}

SingleThumbnail.propTypes ={
  src: propTypes.string,
  alt: propTypes.string,
  noImage: propTypes.bool,
  className: propTypes.string
}

SingleThumbnail.defaultProps = {
  noImage: false
}

export default SingleThumbnail;